export class FieldHelpers {
    public static disableAutoFill(element: HTMLInputElement) {
        element.name = `${Math.floor(Math.random() * 1000)}`;
        element.autocomplete = 'off';
    }

    public static enableAutoFill(element: HTMLInputElement, name: string, autoComplete: string) {
        element.name = name;
        element.autocomplete = autoComplete;
    }
}
